'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getArrayDataFromWorkbook;

var _xlsx = require('xlsx');

var _xlsx2 = _interopRequireDefault(_xlsx);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getArrayDataFromWorkbook(workbook) {
  try {
    return _xlsx2.default.utils.sheet_to_row_object_array(workbook.Sheets[workbook.SheetNames[0]]);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return [];
  }
}